import * as resourceBundle from 'src/assets/resource-bundle/index'

export interface ResourceBundle {
  "label.guestinfo.loyalty.header": string
  "label.vaccination.reminder.takeover.headline"?: string
  "label.vaccination.reminder.takeover.subcopy"?: string
  "label.boardingpass.protocols.keepingyousafe": string
  "label.boardingpass.protocols.healthsafety": string
  "label.healthcenter.preparing.subcopy": string
  "label.healthcenter.preparing.header": string
  "label.healthcenter.saildates": string
  "label.healthcenter.ship": string
  "label.healthcenter.healthycruising.subcopy": string
  "label.healthcenter.healthycruising.header": string
  "label.safety.takeover.headline": string
  "label.safety.takeover.subcopy": string
  "label.safety.takeover.questions": string
  "label.safety.takeover.visit": string
  "label.guestselect.safety.headline": string
  "label.guestselect.safety.subcopy": string
  "no.arrival.times.error.message": string
  "label.contracts.questions": string
  "label.contracts.callus": string
  "label.risk.acknowledgement.title": string
  "label.contract.affirm.int.a": string
  "label.contract.affirm.int.b": string
  "label.boarding.pass.not.cleared.to.board": string
  "label.boarding.pass.before.boarding.must": string
  "label.boarding.pass.answer.questions": string
  "label.boarding.pass.wellness.at.terminal": string
  "label.mobile.app.download.required": string
  "label.boarding.pass.digial.pass.ready": string
  "label.boarding.pass.use.the.app.a": string
  "label.boarding.pass.use.the.app.b": string
  "label.boarding.pass.use.the.app.c": string
  "label.boarding.pass.stay.healthy": string
  "label.boarding.pass.day.before.your.cruise": string
  "label.boarding.pass.complete.questionnaire": string
  "label.boarding.pass.avoid.lines": string
  "label.boarding.pass.boarding.day": string
  "label.boarding.pass.honor.arrival.time": string
  "label.boarding.pass.our.medical.staff.expecting": string
  "label.boarding.pass.onboard": string
  "label.boarding.pass.get.connected": string
  "label.boarding.pass.the.app.helps": string
  "label.boarding.bring.boarding.documents": string
  "label.boarding.bring.boarding.documents.description": string
  "label.arrival.at.the.terminal": string
  "label.arrival.implementing.advanced.screening.description": string
  "label.arrival.make.sure.you": string
  "label.arrival.wear.ppe": string
  "label.arrival.wear.ppe.description": string
  "label.arrival.arrive.on.time": string
  "label.arrival.arrive.on.time.content": string
  "label.arrival.arrive.on.time.description": string
  "label.arrival.wash.your.hands": string
  "label.arrival.wash.your.hands.description": string
  "label.arrival.keep.your.distance": string
  "label.arrival.keep.your.distance.description": string
  "label.contract.affirm.a": string
  "label.contract.affirm.b": string
  "label.arrival.select.arrival.time": string
  "label.arrival.required.arrival.time": string
  "label.arrival.medical.appointment": string
  "label.arrival.read.more": string
  "label.arrival.read.less": string
  "label.arrival.note.missing.appointment": string
  "label.arrival.choose.available.slot": string
  "label.arrival.available.time.slots": string
  "label.access.digital.boarding.pass": string
  "label.answer.health.check": string
  "label.embark.safely": string
  "label.subheader.credit.card.only": string
  "label.header.credit.card": string
  "label.select.no": string
  "label.select.yes": string
  "label.card.save": string
  "label.recent.travel": string
  "label.card.add": string
  "label.card.replace": string
  "label.questionnaire.q1": string
  "label.questionnaire.q2": string
  "emergency.contact.header.description": string
  "biometrics.photo.consent.header": string
  "ssp.category": string
  "payway.header": string
  "payway.subheader": string
  "validation.cc.invalid.number": string
  "cc.error.message": string
  "cc.decline.error.message": string
  "biometrics.self.terms": string
  "biometrics.proxy.terms": string
  "biometrics.checkbox.one": string
  "biometrics.checkbox.two": string
  "arrival.time.unavailable": string
  "ssp.sailing.date"? : string
  "cuba.banner.message": string
  "photo.modal.error.resolution": string
  "photo.modal.error.size": string
  "photo.modal.error.format": string
  "photo.modal.error.webcam": string
  "terms.of.service.modal.header": string
  "cc.tc.message1": string
  "cc.tc.message2": string
  "cc.tc.message3": string
  "app.modal.header": string
  "app.modal.subheader": string
  "app.modal.footnote": string
  "biometric.consent.paragraph": string
  "biometric.consent.link": string
  "data.privacy.modal.header": string
  "data.privacy.modal.content1": string
  "data.privacy.modal.content2": string
  "data.privacy.modal.content3": string
  "data.privacy.modal.content4": string
  "data.privacy.modal.content5": string
  "data.privacy.modal.content6": string
  "data.privacy.modal.content7": string
  "data.privacy.modal.content8": string
  "data.privacy.modal.content9": string
  "temporary.address.subheader": string
  "modal.content.currency.conversion": string
  "ssp.celebrity.cruises.title": string
  "button.curtesy.holds": string
  "footer.brand": string
  "ssp.stateroom": string
  "header.currency.conversion": string
  "checkbox.currency.conversion": string
  "link.currency.conversion": string
  "modal.header.currency.conversion": string
  "button.past.cruise": string
  "header.user.menu.royal.gifts": string
  "ssp.header": string
  "validation.global.maximum.characters.9": string
  "validation.global.maximum.characters.12": string
  "validation.global.maximum.characters.14": string
  "validation.global.maximum.characters.25": string
  "validation.global.maximum.characters.30": string
  "error.address": string
  "tooltip.locked.booking": string
  "banner.message.locked.booking": string
  "guest.booking.unavailable.label": string
  "ssp.expedited.arrival.flag": string
  "ssp.rcl.logo": string
  "ssp.arrival.appointment.title": string
  "ssp.muster.title": string
  "ssp.port.title": string
  "ssp.gty.text.reprint": string
  "qq.cruise.history.modal1": string
  "header.cruise.history.modal1": string
  "skip.cruise.history.modal1": string
  "header.cruise.history.modal2": string
  "subheader.cruise.history.modal2": string
  "done.cruise.history.modal2": string
  "guest.details.remove.selected.guest.label.finish.later": string
  "footer.link.contact.us": string
  "error.global.incorrect.information": string
  "error.contracts.not.complete": string
  "validation.ctc.contract.minor": string
  "appointment.arrival.validation.select.one": string
  "immigration.document.label.drivers.license.state": string
  "immigration.document.label.birth.certificate.state": string
  "label.reservation.title": string
  "label.guestinfo.address.header": string
  "label.guestinfo.address.address1": string
  "label.guestinfo.address.address2": string
  "label.guestinfo.address.city": string
  "label.guestinfo.address.state": string
  "label.guestinfo.address.country": string
  "label.guestinfo.address.zip": string
  "label.pending": string
  "header.boarding.pass.print.page": string
  "print.button.boarding.pass.print.page": string
  "header.user.menu.reservations": string
  "header.user.menu.profile": string
  "header.user.menu.sign.out": string
  "label.appointment.arrival.description": string
  "guest.summary.contracts.agreed": string
  "immigration.document.label.address": string
  "button.print.contracts": string
  "title.confimation": string
  "label.more.guests": string
  "label.dashboard": string
  "button.dashboard": string
  "photo.label.editphoto": string
  "photo.label.addphoto": string
  "photo.modals.header": string
  "photo.requirementsmodal.req1": string
  "photo.requirementsmodal.req2": string
  "photo.requirementsmodal.req3": string
  "photo.requirementsmodal.req4": string
  "photo.takeuploadmodal.opencamera": string
  "photo.uploadmodal.differentphoto": string
  "photo.modals.savephoto": string
  "photo.cameramodal.takephoto": string
  "guest.details.remove.selected.guest.label.line1": string
  "guest.details.remove.selected.guest.label.finish": string
  "ctc.email.header": string
  "ctc.email.label": string
  "ctc.international.content": string
  "ctc.select.primary.country.field.label"?: string
  "ctc.error.no.country.selected"?: string
  "button.save": string
  "label.first.name": string
  "label.last.name": string
  "label.phone": string
  "label.email": string
  "button.help": string
  "button.about.us": string
  "button.privacy": string
  "button.legal": string
  "button.site.map": string
  "button.skip": string
  "name.tooltip": string
  "ctc.warning": string
  "landing.page.title.select.guests": string
  "landing.page.subtitle.select.guests": string
  "landing.page.title.checked.in.guests": string
  "label.boarding.pass": string
  "tool.tip.luggage.tag.pending": string
  "tool.tip.boarding.pass.pending": string
  "personal.details.header": string
  "personal.details.contact.us": string
  "personal.details.update.info": string  
  "guest.info.saving.modal.header": string
  "guest.info.saving.modal.subtitle": string
  "guest.info.saving.validation.message": string
  "guest.info.saving.modal.yes": string
  "guest.info.saving.modal.no": string
  "label.middle.name": string
  "button.no": string
  "label.date.of.birth": string
  "label.gender": string
  "address.label.address": string
  "address.label.zip": string
  "address.label.city": string
  "address.label.state": string
  "contact.info.header.title": string
  "emergency.contact.header": string
  "label.name": string
  "immigration.header": string
  "immigration.label.country.of.citizenship": string
  "immigration.document.label.document.type": string
  "immigration.document.label.document.number": string
  "immigration.document.label.state.id.issuing.state": string
  "immigration.document.label.country.of.birth": string
  "immigration.international.flow.question": string
  "photo.header": string
  "photo.label.upload.mobile": string
  "photo.description.upload": string
  "photo.button.retake": string
  "expense.account.header.description": string
  "expense.account.change.card": string
  "expense.account.add.card": string
  "expense.account.title.payment.type.credit.card": string
  "expense.account.title.payment.type.none": string
  "expense.account.label.credit.card.number": string
  "expense.account.label.expiration.date": string
  "expense.account.label.security.code": string
  "expense.account.label.zip.code": string
  "expense.account.label.name": string
  "expense.account.header.credit.card.authorization": string
  "expense.account.description.credit.card.authorization": string
  "expense.account.title.credit.card.authorization.terms": string
  "expense.account.title.credit.card.authorization.terms.1": string
  "expense.account.button.add.more.guests.yes": string
  "ctc.header": string
  "ctc.international.description": string
  "appointment.arrival.change.link": string
  "button.submit": string
  "button.close": string
  "button.back": string
  "label.luggage.tags": string
  "button.continue": string
  "button.complete.check.in": string
  "button.return.to.guest.list": string
  "time.out.session.title": string
  "time.out.button.log.out": string
  "validation.expense.account.card.name": string
  "validation.expense.account.card.expiration.date": string
  "validation.expense.account.full.card.number": string
  "validation.invalid.security.code": string
  "validation.invalid.maxlength.security.code": string
  "validation.invalid.minlength.security.code": string
  "validation.invalid.zip.code": string
  "validation.invalid.maxlength.zip.code": string
  "validation.immigration.passport.expiration.date": string
  "validation.immigration.passport.expiration.date.six.months": string
  "validation.immigration.document.number.already.entered": string
  "validation.immigration.inline.5.characters": string
  "validation.immigration.inline.no.special.characters": string
  "validation.immigration.inline.valid.document.number": string
  "error.global.required.info": string
  "validation.global.characters1": string
  "validation.global.characters.numbers.only": string
  "validation.global.value.must.be.selected": string
  "validation.global.email.format": string
  "validation.global.minimum.characters.6": string
  "validation.global.minimum.characters.4": string
  "validation.global.maximum.characters.19": string
  "validation.global.maximum.characters.60": string
  "validation.global.maximum.characters": string
  "validation.address.characters": string
  "validation.address.postal.characters": string
  "validation.global.phone": string
  "validation.personal.details.dob.after.today": string
  "validation.invalid.date": string
  "validation.invalid.date.6months": string
  "error.technical.difficulties.header": string
  "error.technical.difficulties.subheader": string
  "error.technical.difficulties.button.dashboard": string
  "ssp.boarding.time.title": string
  "error.check.in.closed.header": string
  "server.error.header": string
  "server.error.subheader": string
  "error.check.in.closed.subtitle": string
  "title.day": string
  "title.month": string
  "title.year": string
  "ssp.onboard.expense.account.title": string
  "ssp.value.stateroom.gty": string
  "expense.account.label.credit.card.number.limited": string
  "label.agreement.i": string
  "expense.account.card.type": string
  "message.modal.leaving.olci.header": string
  "message.modal.leaving.olci.subheader": string
  "button.cancel": string
  "validation.ctc.contract.signed": string
  "time.out.message.15.minutes.inactivity": string
  "time.out.message.15.minutes.inactivity2": string
  "time.out.header.still.there.question": string
  "time.out.message.minute.inactivity": string
  "time.out.message.15.minutes.inactivity3": string
  "time.out.label.extend.time": string
  "expense.account.credit.card.terms": string
  "ssp.ship.title": string
  "ssp.deck.title": string
  "boarding.pass.terminal.title": string
  "ssp.stateroom.title": string
  "spp.cash.title": string
  "user.menu.label.my.account": string
  "progress.bar.guest": string
  "progress.bar.onboard.expenses": string
  "progress.bar.contracts": string
  "progress.bar.arrival": string
  "label.language.selector": string
  "ssp.printed.title": string
  "button.okay": string
  "terms.of.service.paragraph1": string
  "terms.of.service.paragraph2": string
  "terms.of.service.paragraph3": string
  "terms.of.service.paragraph4": string
  "terms.of.service.paragraph5": string
  "terms.of.service.paragraph6": string
  "terms.of.service.paragraph7": string
  "terms.of.service.paragraph8": string
  "terms.of.service.paragraph9": string
  "terms.of.service.paragraph10": string
  "terms.of.service.paragraph11": string
  "terms.of.service.paragraph12": string
  "terms.of.service.paragraph13": string
  "document.type.birth_certificate.state.id.card": string
  "document.type.birth_certificate.drivers.license": string
  "document.type.birth_certificate.student.id.card": string
  "document.type.birth_certificate.military.id.card": string
  "document.type.birth_certificate.born.in.puerto.rico": string
  "document.type.enhanced.drivers.license": string
  "document.type.enhanced.drivers.license.not.real.id": string
  "label.cruise.survey.header": string
  "label.cruise.survey.subheader": string
  "cruise.survey.question.is.first.cruise": string
  "cruise.survey.question.i.have.cruised.first.rccl.cruise": string
  "cruise.survey.question.i.have.sailed.in.the.past": string
  "error.response.is.required": string
  "mobile.number.invalid": string
}
abstract class ResourceBundleClass {
  abstract getResourceBundle(): ResourceBundle;
}
export class ResourceBundleEnglishRoyalProd  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleEnglishRoyalProd;
  }
}
export class ResourceBundleSpanishRoyalProd extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleSpanishRoyalProd;
  }
}
export class ResourceBundlePortugueseRoyalProd extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundlePortugueseRoyalProd;
  }
}
export class ResourceBundleFrenchRoyalProd extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleFrenchRoyalProd;
  }
}
export class ResourceBundleEnglishRoyalStage  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleEnglishRoyalStage;
  }
}
export class ResourceBundleSpanishRoyalStage  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleSpanishRoyalStage;
  }
}
export class ResourceBundlePortugueseRoyalStage  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundlePortugueseRoyalStage;
  }
}
export class ResourceBundleFrenchRoyalStage  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleFrenchRoyalStage;
  }
}
export class ResourceBundleEnglishRoyalTest  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleEnglishRoyalTest;
  }
}
export class ResourceBundleSpanishRoyalTest  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleSpanishRoyalTest;
  }
}
export class ResourceBundlePortugueseRoyalTest  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundlePortugueseRoyalTest;
  }
}
export class ResourceBundleFrenchRoyalTest  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleFrenchRoyalTest;
  }
}
export class ResourceBundleEnglishCelebrityProd  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleEnglishCelebrityProd;
  }
}
export class ResourceBundleEnglishCelebrityStage  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleEnglishCelebrityStage;
  }
}
export class ResourceBundleEnglishCelebrityTest  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleEnglishCelebrityTest;
  }
}
export class ResourceBundleFrenchCelebrityProd  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleFrenchCelebrityProd;
  }
}
export class ResourceBundleFrenchCelebrityStage  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleFrenchCelebrityStage;
  }
}
export class ResourceBundleFrenchCelebrityTest  extends ResourceBundleClass {
  getResourceBundle() {
    return resourceBundle.resourceBundleFrenchCelebrityTest;
  }
}